import { Injectable } from '@angular/core';
import { Observable, of, share, tap } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class GlobalSelectCacheService {

    private cache = new Map<string, any[]>();
    private pending = new Map<string, Observable<any[]>>();

    buildKey(type: string, params: any): string {
        return `${type}__${JSON.stringify(params)}`;
    }

    has(key: string): boolean {
        return this.cache.has(key);
    }

    get(key: string): any[] {
        return this.cache.get(key) ?? [];
    }

    set(key: string, items: any[]): void {
        this.cache.set(key, items);
    }

    getOrSetPending(key: string, request$: Observable<any[]>): Observable<any[]> {
        if (this.pending.has(key)) {
            return this.pending.get(key)!;
        }

        const shared$ = request$.pipe(
            tap(items => this.set(key, items)),
            share(),
        );

        this.pending.set(key, shared$);
        return shared$;
    }

    invalidate(type: string): void {
        for (const key of this.cache.keys()) {
            if (key.startsWith(`${type}__`)) {
                this.cache.delete(key);
            }
        }
    }

    clear(): void {
        this.cache.clear();
    }
}
